var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:view-dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.703 6.32074H27.4331V14.3683H16.703V6.32074ZM16.703 29.1221V15.7096H27.4331V29.1221H16.703ZM4.6317 29.1221V21.0746H15.3618V29.1221H4.6317ZM4.6317 19.7333V6.32074H15.3618V19.7333H4.6317ZM5.97296 7.662V18.3921H14.0205V7.662H5.97296ZM18.0443 7.662V13.027H26.0918V7.662H18.0443ZM18.0443 17.0508V27.7809H26.0918V17.0508H18.0443ZM5.97296 22.4158V27.7809H14.0205V22.4158H5.97296Z",
    fill: "#3A3A3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsProgram);
export default __webpack_public_path__ + "static/media/settings-program.b44bc5b7d9e2e2725e8235d9fc662354.svg";
export { ForwardRef as ReactComponent };